// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldorgEntity from './entities/ldorg.json';
import ldorgMenu from '../pages/ldorg/menu.json';
import ldorgFullForm from '../pages/ldorg/forms/full.json';
import ldorgContextForm from '../pages/ldorg/forms/context.json';
import ldorgMiniForm from '../pages/ldorg/forms/mini.json';
import ldorgLookupForm from '../pages/ldorg/forms/lookup.json';
import ldorgTableView from '../pages/ldorg/views/table.json';
import ldorgStagesView from '../pages/ldorg/views/stages.json';
import ldorgCardsView from '../pages/ldorg/views/cards.json';
import ldorgInlineView from '../pages/ldorg/views/inline.json';
import ldorgBacklogView from '../pages/ldorg/views/backlog.json';
import ldorgSplitView from '../pages/ldorg/views/split.json';
import ldorgCalendarView from '../pages/ldorg/views/calendar.json';
import ldorgDashboardView from '../pages/ldorg/views/dashboard.json';

/** Тип запису «Регульована структура» зі сторінками пакета: меню, форми та подання з pages/ldorg/. */
export const ldorgDefinition: IRecordTypeDefinition = {
  ...ldorgEntity,
  views: assembleViewSet({
      table: ldorgTableView,
      stages: ldorgStagesView,
      cards: ldorgCardsView,
      inline: ldorgInlineView,
      backlog: ldorgBacklogView,
      split: ldorgSplitView,
      calendar: ldorgCalendarView,
      dashboard: ldorgDashboardView,
  }),
  form: ldorgFullForm,
  forms: { full: ldorgFullForm, context: ldorgContextForm, mini: ldorgMiniForm, lookup: ldorgLookupForm },
  menu: ldorgMenu,
} as IRecordTypeDefinition;
